const STORAGE_KEY = "basket";

class BasketStoreClass {
    constructor() {
        this.products = this.load();
        this.listeners = new Set(); // subscribed components
    }

    load() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
        } catch {
            return [];
        }
    }

    save() {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.products));
        this.notify();
    }

    notify() {
        this.listeners.forEach(callback => callback(this.products));
    }

    subscribe(callback) {
        this.listeners.add(callback);
        callback(this.products);
        return () => this.listeners.delete(callback);
    }

    add(product) {
        const existing = this.products.find(p => p.id === product.id);

        if (existing) {
            existing.quantity += product.quantity || 1;
        } else {
            this.products.push({ ...product, quantity: product.quantity || 1 });
        }

        this.save();
    }

    update_quantity(product_id, quantity) {
        if (quantity === 0) {
            this.remove(product_id);
            return;
        }

        const existing = this.products.find(p => p.id === product_id);

        if (existing) {
            existing.quantity = quantity;
        }
    }

    remove(product_id) {
        this.products = this.products.filter(p => p.id !== product_id);
        this.save();
    }

    clear() {
        this.products = [];
        this.save();
    }
}

export const BasketStore = new BasketStoreClass();
